export const VideoControls = (function () {
	'use strict';

	let $video_controls, $video;

	function init() {
		$video_controls = $('[data-video-toggle]');

		$video_controls.click(function(){
			let $t = $(this),
					$video = $t.siblings('video');

			const video = $video[0]
			if (video.paused) {
				$t.text('Pause Video');
				$t.removeClass('play').addClass('pause');
				$t.attr('aria-pressed', 'true');
				video.play();
			} else {
				$t.text('Play Video');
				$t.removeClass('pause').addClass('play');
				$t.attr('aria-pressed', 'false');
				video.pause();
			}
		});
	}

	return {
		init: init,
	};
})();
